import type { QueryClient } from '@tanstack/react-query';

import type { Configuracao } from '@/api/secretario';
import { queryKeys } from '@/lib/pwa/queryConfig';
import { getConfiguracaoAtual } from '@/lib/secretario/configuracaoAtual';

/**
 * Grava no cache a configuração que uma ação devolveu — só se ela ainda é a escolhida.
 * A chave do cache é a do Secretário escolhido NA HORA (``escopoDoCache``): trocar o
 * seletor durante a gravação faria a resposta de um cair no cache do outro, e o
 * próximo "Salvar" mandaria os dados de um para o outro.
 */
export function gravarConfigNoCache(queryClient: QueryClient, atualizada: Configuracao): void {
  const escolhida = getConfiguracaoAtual();
  if (escolhida === null || escolhida === atualizada.id) {
    queryClient.setQueryData(queryKeys.secretario.config, atualizada);
  } else {
    queryClient.invalidateQueries({ queryKey: ['secretario', atualizada.id] });
  }
}
